import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import SectionList from './section-list.component';
import SectionCreate from './section-create.component';
import SectionView from './section-view.component';
import SectionEdit from './section-edit.component';
import SectionCopy from './section-copy.component';
import SectionDelete from './section-delete.component';

interface Props {
  root?: string;
}

export const SectionRouteQuiz: React.FunctionComponent<Props> = (props) => {
  return (
    <Switch>
      <Route path={`${props.root||''}/quizsection/create`} render={(params) => <SectionCreate {...params} key={params.history.location.key} caption='Create Quiz Section' tag='quizsection' />} />        
      <Route path={`${props.root||''}/quizsection/view`} render={(params) => <SectionView {...params} key={params.history.location.key} root={props.root} caption='View Quiz Section' tag='quizsection' />} />        
      <Route path={`${props.root||''}/quizsection/edit`} render={(params) => <SectionEdit {...params} key={params.history.location.key} root={props.root} caption='Edit Quiz Section' tag='quizsection' />} />
      <Route path={`${props.root||''}/quizsection/copy`} render={(params) => <SectionCopy {...params} key={params.history.location.key} caption='Copy Quiz Section' tag='quizsection' />} />        
      <Route path={`${props.root||''}/quizsection/delete`} render={(params) => <SectionDelete {...params} key={params.history.location.key} root={props.root} caption='Delete Quiz Section' tag='quizsection' />} />        
      <Route path={(props.root||'') + '/quizsection'} render={(params) => <SectionList {...params} root={props.root} caption='Quiz Section' tag='quizsection' />} /> 
    </Switch>
  );
}
